import { z } from 'zod';

import { mongoIdSchema } from './shared';

export enum MediaKind {
  ProductImage = 'productimage',
  ProductDocument = 'productdoc',
  ContentImage = 'contentimage',
  ContentDocument = 'contentdoc',
}

export const mediaCreateSchema = z.object({
  refDocId: mongoIdSchema,
  organizationId: mongoIdSchema,

  kind: z.enum([
    MediaKind.ProductImage,
    MediaKind.ProductDocument,
    MediaKind.ContentImage,
    MediaKind.ContentDocument,
  ]),
  url: z.string().trim(),
});
export type MediaCreate = z.infer<typeof mediaCreateSchema>;

export const mediaSchema = z
  .object({
    _id: mongoIdSchema,
    createdAt: z.number(),
    updatedAt: z.number(),
  })
  .merge(mediaCreateSchema);

export type Media = z.infer<typeof mediaSchema>;
